<template>
  <div class="flex flex-col gap-6 justify-items-center items-center">
    <img src="https://albarra.world/cms/assets/2543d3de-0844-49e1-9ab4-ecfbf31a7420" alt="" style="max-width: 350px;margin: 0% auto;">
    <Typography size="main-xl" class="text-center leading-none text-nowrap">Other Page linked!</Typography>
    <div class="w-1/6 h-[0.25rem] bg-red-500 mx-auto"></div>
    <span class="flex flex-col gap-2">
      <Typography size="secondary-book" class="text-center">Congrats! You've succesfully linked your Other Page to the Albarra Woods and have earned the right to claim the Other Page x Albarra badge!</Typography>
    </span>
    <Button @click="onClickClaim"
            class="h-16 px-10 bg-primary font-bold text-2xl flex items-center justify-center gap-4">
      <span style="font-size: 40pt; font-family: Ravenholm;font-weight: normal !important;">Claim Badge + 30</span> <img src="~/assets/svg/troncos.svg" class="w-6 h-6" />
    </Button>
  </div>
</template>
  
<script setup>
import Typography from "@/components/common/Typography.vue"
import { cmsStore } from "../../stores/cmsStore";
import { useModalsStore } from '../../stores/useModalsStore'

const modalsStore = useModalsStore()
const cms = cmsStore();

const onClickClaim = () => {
  cms.userHasOtherPageBadge()
     .then(response => {
        console.log(response)
        if (response.code === 'success-badge-assigned-now') {
          modalsStore.closeModal()
          window.location.href = '/badges'
        }
     })
}

const closeModal = () => {
  modalsStore.closeModal()
  navigateTo('/badges')
}
</script>
  
<style scoped>
</style>
  